import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=10d8dde9"
import script from "./InvoiceSummary.vue?vue&type=script&lang=ts"
export * from "./InvoiceSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d8dde9')) {
      api.createRecord('10d8dde9', component.options)
    } else {
      api.reload('10d8dde9', component.options)
    }
    module.hot.accept("./InvoiceSummary.vue?vue&type=template&id=10d8dde9", function () {
      api.rerender('10d8dde9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invoice/InvoiceForm/InvoiceSummary.vue"
export default component.exports